define("shared/utils/handle-key-down", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = handleKeyDown;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   * @extends Utils
   *
   *
   * Performs a function when a specific key is pressed
   *
   * @method handleKeyDown
   *
   * @param {KeyboardEvent} event The keyboard event
   * @param {{code: string, key: string}} key The desired event key from lib/shared/addon/utils/constants/keys.js
   * @param {Function} action The function to perform when the key is pressed
   *
   */
  function handleKeyDown(event, key, action) {
    const eventKey = event.code || event.key;

    if (eventKey === key.code || eventKey === key.key) {
      event.preventDefault();
      action();
    }
  }
});